import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Header from './components/Header';
import Login from './components/Login';
import Register from './components/Register';
import MovieSearch from './components/MovieSearch';
import NewKriticalMoviesPage from './components/NewKriticalMoviesPage';
import KriticalWatchingPage from './components/KriticalWatchingPage';
import MyMovies from './components/MyMovies';
import Profile from './components/Profile';
import Kritics from './components/Kritics';
import KriticDetail from './components/KriticDetail';
import MovieDetail from './components/MovieDetail';
import WannaWatch from './components/WannaWatch';
import About from './components/About';
import BetaTermsModal from './components/BetaTermsModal';
import AdminPortal from './components/AdminPortal';
import Landing from './components/Landing';
import LetterboxdImport from './components/LetterboxdImport';
import api from './services/api';
import { GlobalStyle, macOSTheme } from './styles/globalStyles';

function App() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);

  const handleLogin = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  const handleAcceptTerms = async () => {
    if (!user) return;
    try {
      await api.acceptBetaTerms(user.id);
      const updatedUser = { ...user, hasAcceptedTerms: true };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      setUser(updatedUser);
    } catch (error) {
      console.error("Failed to accept terms:", error);
    }
  };

  return (
    <ThemeProvider theme={macOSTheme}>
      <GlobalStyle />
      <Router>
        <div className="app-container">
          <Header user={user} onLogout={handleLogout} />
          <main className="content">
            {user && !user.hasAcceptedTerms && (
              <BetaTermsModal
                open={true}
                onAccept={handleAcceptTerms}
                onLogout={handleLogout}
              />
            )}
            <Routes>
              <Route path="/" element={user ? <MovieSearch /> : <Landing />} />
              <Route path="/new-kritical-movies" element={user ? <NewKriticalMoviesPage user={user} /> : <Navigate to="/" />} />
              <Route path="/kritical-watching" element={user ? <KriticalWatchingPage user={user} /> : <Navigate to="/" />} />
              <Route path="/login" element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} />
              <Route path="/register" element={!user ? <Register onLogin={handleLogin} /> : <Navigate to="/" />} />
              <Route path="/my-movies" element={user ? <MyMovies userId={user.id} /> : <Navigate to="/" />} />
              <Route path="/profile" element={user ? <Profile user={user} /> : <Navigate to="/" />} />
              <Route path="/kritics" element={user ? <Kritics /> : <Navigate to="/" />} />
              <Route path="/kritics/:siteIdentifier" element={user ? <KriticDetail /> : <Navigate to="/" />} />
              <Route path="/movies/:slug" element={user ? <MovieDetail /> : <Navigate to="/" />} />
              <Route path="/wanna-watch" element={user ? <WannaWatch /> : <Navigate to="/" />} />
              <Route path="/import/letterboxd" element={user ? <LetterboxdImport user={user} /> : <Navigate to="/" />} />
              <Route path="/about" element={<About />} />
              <Route path="/admin" element={user && user.isAdmin ? <AdminPortal /> : <Navigate to="/" />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
